module.exports = __webpack_public_path__ + "static/img/gongan.f0725487.png";